// frontend/src/pages/Proposals/PortalProposals.jsx
// Vendor-facing: list own proposals and their status
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Plus, ChevronRight } from "lucide-react";
import { getProposals } from "../../api/proposal.api.js";
import { PageHeader, Spinner, EmptyState, StatusBadge, formatDate } from "../../components/ui";

export default function PortalProposals() {
  const { data: proposals, isLoading } = useQuery({
    queryKey: ["my-proposals"],
    queryFn: () => getProposals(),
  });

  return (
    <div>
      <PageHeader
        title="Pengajuan Perjanjian"
        subtitle="Daftar pengajuan perjanjian yang telah Anda kirimkan."
        action={
          <Link
            to="/portal/proposals/new"
            className="btn-primary flex items-center gap-1.5 text-sm"
          >
            <Plus size={15} /> Ajukan Baru
          </Link>
        }
      />

      {isLoading ? (
        <Spinner />
      ) : !proposals?.length ? (
        <EmptyState
          title="Belum ada pengajuan"
          description='Klik "Ajukan Baru" untuk mulai mengajukan perjanjian ke tim Legal.'
          action={
            <Link to="/portal/proposals/new" className="btn-primary text-sm">
              Ajukan Sekarang
            </Link>
          }
        />
      ) : (
        <div className="card divide-y divide-gray-100">
          {proposals.map((p) => (
            <Link
              key={p.id}
              to={`/portal/proposals/${p.id}`}
              className="flex items-center gap-4 px-5 py-4 hover:bg-gray-50 transition-colors"
            >
              <div className="flex-1 min-w-0">
                <p className="font-medium text-gray-900 truncate">{p.title}</p>
                <p className="text-sm text-gray-500 truncate mt-0.5">{p.purpose}</p>
                <p className="text-xs text-gray-400 mt-0.5">{formatDate(p.createdAt)}</p>
              </div>
              <StatusBadge status={p.status} />
              <ChevronRight size={16} className="text-gray-300 shrink-0" />
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
